import { render, staticRenderFns } from "./ExtraClassAddStudentDialog.vue?vue&type=template&id=b15b5504&scoped=true"
import script from "./ExtraClassAddStudentDialog.vue?vue&type=script&lang=js"
export * from "./ExtraClassAddStudentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15b5504",
  null
  
)

export default component.exports